/** Persisted on `Analyses.Status` (API). `final` means the analysis is read-only. */
export const ANALYSIS_STATUS_EDITABLE = 'editable';
export const ANALYSIS_STATUS_FINAL = 'final';

export function isAnalysisLocked(status: string | null | undefined): boolean {
  return (
    String(status ?? '')
      .trim()
      .toLowerCase() === ANALYSIS_STATUS_FINAL
  );
}
